import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6.72 0 .69.69q.33.33.3.57 0 .21-.33.54L2.52 6.63l4.86 4.83q.33.33.33.57.03.21-.3.54l-.69.69L.57 7.17Q0 6.63.57 6.09z"
    }, null, -1)
  ]))]))
}
export default { render: render }